module.exports = require('./helpers/bundle-url').getBundleURL('g5qyd') + "logo.c51670a8.svg";